export const environment = {
    production: false,
    apiUrl: 'https://yxadmin-stg-aws.transnetyx.com/api',

    auth0: {
        domain: 'login-stg.transnetyx.com',
        clientId: 'dZ51sesaL6Wkhe0FXzYjLJFkcRtC7NL1',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-stg.transnetyx.com/v2/logout/order-manager`,
        logoutUrl: 'https://login-stg.transnetyx.com/v2/logout',
    },

    colonyUrl: 'https://colony-stg.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder-stg.transnetyx.com/Default.aspx',
    geneticMonitoringUrl: 'https://quickorder-stg.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder-stg.transnetyx.com/MVC/Microbiome/home',
    quickorderUrl: 'https://quickorder-stg.transnetyx.com/MVC/Account/Register',
    quickorderStrainUrl: 'https://quickorder-stg.transnetyx.com/Strain.aspx',

    omDashboardUrl: 'https://ordermanager-stg.transnetyx.com/',
    omAccountsUrl: 'https://ordermanager-stg.transnetyx.com/Accounts/Default.aspx',
    omAssaysUrl: 'https://ordermanager-stg.transnetyx.com/AssayDesign/Default.aspx',
    omOrdersUrl: 'https://ordermanager-stg.transnetyx.com/Orders/Default.aspx',
    omPricingUrl: 'https://ordermanager-stg.transnetyx.com/Pricing/Default.aspx',
    omProbesUrl: 'https://ordermanager-stg.transnetyx.com/PredefinedProbes/Default.aspx',
    omPmUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/Default.aspx',
    omSalesUrl: 'https://ordermanager-stg.transnetyx.com/Sales/Dashboard.aspx',
    omShippingUrl: 'https://ordermanager-stg.transnetyx.com/Shipping/SupplyRequests.aspx',
    omStrainsUrl: 'https://ordermanager-stg.transnetyx.com/Strains/Default.aspx',
    omTagCenterUrl: 'https://ordermanager-stg.transnetyx.com/TAG/Default.aspx',
    omAccountOverviewUrl: 'https://ordermanager-stg.transnetyx.com/Accounts/User.aspx',
    omBannerSettingsUrl: 'https://ordermanager-stg.transnetyx.com/Admin/Banners/Default.aspx',
    omAccountsOrganizationsUrl: 'https://ordermanager-stg.transnetyx.com/Accounts/Organizations.aspx',
    omAccountsOnlineUsersUrl: 'https://ordermanager-stg.transnetyx.com/Accounts/UsersOnline.aspx',
    omAssaysSearchUrl: 'https://ordermanager-stg.transnetyx.com/AssayDesign/Search.aspx',
    omAssaysSequencingUrl: 'https://ordermanager-stg.transnetyx.com/AssayDesign/Sequencing.aspx',
    omAssaysProbesMfgUrl: 'https://ordermanager-stg.transnetyx.com/AssayDesign/ProbeManufacturing.aspx',
    omAssaysIncompleteSIFsUrl:
        'https://ordermanager-stg.transnetyx.com/AssayDesign/IncompleteStrainInformationForms.aspx',
    omAssaysConstructsUrl: 'https://ordermanager-stg.transnetyx.com/AssayDesign/Constructs.aspx',
    omOrdersCreateUrl: 'https://ordermanager-stg.transnetyx.com/Orders/OrderCreate.aspx',
    omOrdersPendingOrdersUrl: 'https://ordermanager-stg.transnetyx.com/Orders/OrdersPending.aspx',
    omOrdersIncompleteOrdersUrl: 'https://ordermanager-stg.transnetyx.com/Orders/OrdersIncomplete.aspx',
    omOrdersWellplateStorageUrl: 'https://ordermanager-stg.transnetyx.com/Orders/WellplateStorage.aspx',
    omPricingPromoCreditsUrl: 'https://ordermanager-stg.transnetyx.com/Pricing/Discounting.aspx',
    omPricingPaymentMethodsUrl: 'https://ordermanager-stg.transnetyx.com/Pricing/PaymentMethods.aspx',
    omProbesAddPredefinedProbesUrl: 'https://ordermanager-stg.transnetyx.com/PredefinedProbes/PredefinedProbeAdd.aspx',
    omProbesABIFileImportUrl: 'https://ordermanager-stg.transnetyx.com/PredefinedProbes/AbiOrderFileImport.aspx',
    omProbesManufacturingUrl: 'https://ordermanager-stg.transnetyx.com/PredefinedProbes/Manufacturing.aspx',
    omProbesSequencingUrl: 'https://ordermanager-stg.transnetyx.com/PredefinedProbes/Sequencing.aspx',
    omProbesIncompatibleProbesUrl: 'https://ordermanager-stg.transnetyx.com/PredefinedProbes/IncompatibleProbes.aspx',
    omPmTasksUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/Tasks.aspx',
    omPmNotesUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/Notes.aspx',
    omPmOrdersLimsUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/OrdersLims.aspx',
    omPmPendingOrdersUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/OrdersPending.aspx',
    omPmOfflineWellplatesUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/WellplatesOffline.aspx',
    omPmOfflineSequencingUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/SequencingTubesOffline.aspx',
    omPmStrainCopyUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/StrainCopy.aspx',
    omPmUnreceivedOrdersUrl: 'https://ordermanager-stg.transnetyx.com/ProjectManagement/OrdersNotReceived.aspx',
    omSalesAssayDesignUrl: 'https://ordermanager-stg.transnetyx.com/Sales/AssayDesign.aspx',
    omSalesNotesUrl: 'https://ordermanager-stg.transnetyx.com/Sales/Notes.aspx',
    omSalesProspectsUrl: 'https://ordermanager-stg.transnetyx.com/Sales/SalesProspects.aspx',
    omShippingCentralShippingUrl: 'https://ordermanager-stg.transnetyx.com/Shipping/CentralShipping.aspx',
    omShippingSequencingUrl: 'https://ordermanager-stg.transnetyx.com/Shipping/Sequencing.aspx',
    omShippingLabelSettingsUrl: 'https://ordermanager-stg.transnetyx.com/Shipping/LabelSettings.aspx',
    omOrderResultsUrl: 'https://ordermanager-stg.transnetyx.com/Orders/OrderResults.aspx',
    omStrainUrl: 'https://ordermanager-stg.transnetyx.com/Strains/Strain.aspx',
    omManagePickupsUrl: 'https://ordermanager-stg.transnetyx.com/Shipping/ManagePickups.aspx',
};
